export default __webpack_public_path__ + "static/media/maximizeIcon.90c0f439.svg";